import { motion } from "framer-motion";
import { Trophy, Users, User, Tent, Sun } from "lucide-react";
import { IMG } from "@/data/siteData";

const items = [
  {
    icon: Users,
    title: "Treningi grupowe",
    desc: "Regularne zajęcia w małych grupach wiekowych — dwa treningi w tygodniu na naszych obiektach w Poznaniu.",
    img: IMG.training,
    big: true,
  },
  {
    icon: User,
    title: "Treningi indywidualne",
    desc: "Praca jeden na jeden z trenerem nad techniką, koordynacją i słabszymi elementami gry.",
    img: IMG.individual,
    big: false,
  },
  {
    icon: Trophy,
    title: "Turnieje",
    desc: "Udział w turniejach w Polsce i za granicą — w tym w lidze Red Box i Pucharze Prezydenta Poznania.",
    img: IMG.tournaments,
    big: false,
  },
  {
    icon: Tent,
    title: "Obozy sportowe",
    desc: "Letnie i zimowe obozy piłkarskie — treningi, integracja i niezapomniane przygody.",
    img: null,
    big: false,
    wide: true,
  },
  {
    icon: Sun,
    title: "Półkolonie",
    desc: "Aktywne wakacje i ferie w mieście — piłka nożna, gry zespołowe i olimpiady sportowe.",
    img: null,
    big: false,
  },
];

export default function WhatWeDo() {
  return (
    <section id="co-robimy" data-testid="whatwedo-section" className="bg-[#EFF6FF] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <span className="font-accent uppercase tracking-[0.3em] text-blue-700 text-xs font-bold">02 — Co robimy</span>
        <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl max-w-2xl text-[#0F172A]">
          Więcej niż zwykłe <span className="text-blue-700">treningi</span>
        </h2>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((item, i) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              data-testid={`whatwedo-card-${i}`}
              className={`group relative border-2 border-blue-100 bg-white overflow-hidden hover:-translate-y-1 hover:border-blue-700 transition-all duration-200 flex flex-col ${item.big ? "md:col-span-2 md:row-span-2" : ""} ${item.wide ? "md:col-span-2" : ""}`}
            >
              {item.img && (
                <div className={`relative overflow-hidden ${item.big ? "h-64 md:h-auto md:flex-1 md:min-h-[22rem]" : "h-40"}`}>
                  <img
                    src={item.img}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white to-transparent" />
                </div>
              )}
              <div className="p-6">
                <item.icon className="text-blue-700 mb-3" size={26} />
                <h3 className="font-display font-black uppercase tracking-tight text-xl text-[#0F172A]">{item.title}</h3>
                <p className="mt-2 text-sm text-slate-600 font-medium leading-relaxed">{item.desc}</p>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          data-testid="whatwedo-photo-strip"
          className="mt-6 relative overflow-hidden border-2 border-blue-100"
        >
          <img
            src="/gallery/g1.jpg"
            alt="Drużyna SMP Wichniarek z medalami Ligi MT Finals 2026"
            loading="lazy"
            className="w-full h-72 md:h-[420px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A8A]/80 via-transparent to-transparent" />
          <div className="absolute bottom-0 left-0 p-6 md:p-10">
            <span className="font-accent uppercase tracking-[0.3em] text-[#FACC15] text-xs font-bold">SMP Wichniarek</span>
            <p className="font-display font-black uppercase tracking-tighter text-white text-2xl md:text-4xl leading-none mt-2">
              Jedna drużyna, jedna pasja
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
